(function($){
  var $tabButton = $('.product-single__tabs-button');
  
  function tabbedGallery(){
    $('.tabbed-slider').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3,
            arrows: true
          }
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3,
            arrows: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            arrows: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            arrows: true
          }
        }
      ]
    });
  };

  tabbedGallery();

  $tabButton.on('click', function(){
    var dataTab = $(this).attr('data-tab-header');
    $('[data-tab-header]').removeClass('product-single__tabs-button--active');
    $(this).addClass('product-single__tabs-button--active');
    $('[data-tab-content]').removeClass('product-single__tabs-text--active').parent('.product-single__tabs-content').hide();
    $('[data-tab-content='+dataTab+']').addClass('product-single__tabs-text--active').parent('.product-single__tabs-content').show();
    $('.tabbed-slider').slick('unslick');
    tabbedGallery();
  });

  
  
  
  $('.block-slider-slide').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    autoplay: false,
    infinite: true,
    pauseOnHover: true
  });
})(jQuery);

$(window).on('load', function(){
  $('.single-collection').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    autoplay: false,
    infinite: true,
    pauseOnHover: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 2
        }
      }
    ]
  });

});  